import React, { useState } from "react";
import { Add } from "@mui/icons-material";
import { Button } from "@mui/material";
import AddDocumentModal from "./GlobalDocuments/AddDocumentModal";
import { PARTICIPANT_LOCKED_MESSAGE } from "../../utils/participantLock";

type Props = {
  setToggleLoader: React.Dispatch<React.SetStateAction<boolean>>;
  isLocked?: boolean;
};

const DocumentHeader = ({ setToggleLoader, isLocked }: Props) => {
  const [showDocumentModal, setShowDocumentModal] = useState(false);

  const refreshPage = () => {
    setToggleLoader((prev: boolean) => !prev);
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={() => setShowDocumentModal(true)}
        startIcon={<Add />}
        disabled={isLocked}
        title={isLocked ? PARTICIPANT_LOCKED_MESSAGE : undefined}
      >
        Add Document
      </Button>
      {showDocumentModal && (
        <AddDocumentModal
          showModal={showDocumentModal}
          closeModal={() => setShowDocumentModal(false)}
          refreshPage={refreshPage}
        />
      )}
    </>
  );
};

export default DocumentHeader;
